import React, { useEffect, useState, useRef } from "react";
import Popup from "./Popup";
import { resetScreens } from "../../redux/actions";
import { useAppDispatch } from "../../redux";
import { RESET_TIME, INACTIVE_TIME } from "../../utils/consts";

interface InactivityCheckProps {
  selectTab: (tab: number) => void;
}

const InactivityCheck: React.FC<InactivityCheckProps> = ({ selectTab }) => {
  const [showPopup, setShowPopup] = useState<boolean>(false);
  const inactiveTimerRef = useRef<NodeJS.Timeout | null>(null);
  const resetScreenTimerRef = useRef<NodeJS.Timeout | null>(null);

  const dispatch = useAppDispatch();

  const resetScreen = () => {
    // console.log("Screen reset");
    selectTab(0);
    closePopup();
    dispatch(resetScreens());
  };

  const resetTimer = () => {
    console.log("Timer reset");
    if (inactiveTimerRef.current) {
      clearTimeout(inactiveTimerRef.current);
    }
    if (resetScreenTimerRef.current) {
      clearTimeout(resetScreenTimerRef.current);
    }

    inactiveTimerRef.current = setTimeout(() => {
      setShowPopup(true);
      resetScreenTimerRef.current = setTimeout(() => {
        // console.log("Executing reset");
        resetScreen();
      }, RESET_TIME * 1000);
    }, INACTIVE_TIME * 1000);
  };

  const closePopup = () => {
    // console.log("Popup closed");
    setShowPopup(false);
    if (resetScreenTimerRef.current) {
      clearTimeout(resetScreenTimerRef.current);
    }
  };

  useEffect(() => {
    document.addEventListener("click", () => resetTimer());

    return () => {
      document.removeEventListener("click", () => resetTimer());
      if (inactiveTimerRef.current) {
        clearTimeout(inactiveTimerRef.current);
      }

      if (resetScreenTimerRef.current) {
        clearTimeout(resetScreenTimerRef.current);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <Popup showPopup={showPopup} closePopup={closePopup} />
    </div>
  );
};

export default InactivityCheck;
